import { TextAreaField, TextField, ToggleField } from "./SettingsFields";

function ContactPageSettingsForm({ settings, onChange }) {
  return (
    <section className="admin-settings-section">
      <ToggleField label="Enable Contact page" name="contact_page_enabled" checked={settings.contact_page_enabled} onChange={onChange} />
      <ToggleField label="Enable contact form" name="contact_form_enabled" checked={settings.contact_form_enabled} onChange={onChange} />
      <TextField label="Eyebrow" name="contact_eyebrow" value={settings.contact_eyebrow} onChange={onChange} />
      <TextField label="Title" name="contact_title" value={settings.contact_title} onChange={onChange} />
      <TextAreaField label="Intro" name="contact_intro" value={settings.contact_intro} onChange={onChange} />
      <TextField label="Contact phone" name="contact_phone" value={settings.contact_phone} onChange={onChange} />
      <TextField label="Contact email" name="contact_email" value={settings.contact_email} onChange={onChange} type="email" />
      <TextAreaField label="Address text" name="contact_address_text" value={settings.contact_address_text} onChange={onChange} />
      <TextAreaField label="Hours text" name="contact_hours_text" value={settings.contact_hours_text} onChange={onChange} />
      <TextField label="Success message" name="contact_success_message" value={settings.contact_success_message} onChange={onChange} />
    </section>
  );
}

export default ContactPageSettingsForm;